import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, mergeProps as _mergeProps, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "contentHeader flex" }
const _hoisted_2 = { class: "contentBox" }
const _hoisted_3 = { class: "block w-full" }
const _hoisted_4 = { class: "flex mb-4" }
const _hoisted_5 = ["title"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "icon-neu" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = ["title", "disabled"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "icon-loeschen" }, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = ["title"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "icon-upload" }, null, -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = ["title", "disabled"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "icon-downlaod" }, null, -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "ml-auto" }
const _hoisted_18 = { class: "text-center" }

import {useSystemStore} from "@/stores/system/SystemStore";
import {BryntumGrid} from "@bryntum/grid-vue-3";
import GridInputFilter from "@/components/system/GridInputFilter.vue";
import {ErrorLocationType, PopupType, TableType, UsersType} from "@/utilities/system/enums/Enums";
import {onBeforeUnmount, onMounted, reactive, ref} from "vue";
import {Menu, Store, StringHelper} from "@bryntum/grid";
import {checkboxColumnConfig, defaultSpaceAroundTableOnPage, featureColumn} from "@/AppConfig";
import {useI18n} from "vue-i18n";
import exportFromJSON from "export-from-json";
import dialog from "@/components/system/dialog";
import {UserService} from "@/utilities/services/entities/UserService";
import FilterService from "@/utilities/system/services/FilterService";
import {User} from "@/models/entities/users/User";
import {UserWithAdditional} from "@/models/entities/users/UserWithAdditional";
import LoadingSpinner from "@/components/system/LoadingSpinner.vue";
import Error from "@/components/system/Error.vue";
import {UserCsvExport} from "@/models/helpers/CsvExportModels";



export default /*#__PURE__*/_defineComponent({
  __name: 'UserManagmentAdditional',
  setup(__props) {

const {t} = useI18n();
const systemStore = useSystemStore();
const userSerivce = new UserService();

const currentWindowHeight = ref("");
const recalcGridHeight = () => {
  currentWindowHeight.value = `${window.innerHeight-defaultSpaceAroundTableOnPage}px`;
};


const selectedUsers = ref([])


const gridStore = new Store()
const grid = ref(null)
const useGridConfig = {
  headerMenuFeature: false,
  relayStoreEvents: true,
  cellTooltipFeature: {
    hoverDelay      : 300,
    textContent     : true,
    hideOnDelegateChange: true,
  },
  enableTextSelection: false,
  selectionMode : {
    row	  : true,
    checkbox: checkboxColumnConfig,
    showCheckAll : true,
    deselectFilteredOutRecords: true
  },
  columns : {
    data: [
      {
        id:'firstName',
        field: 'firstName',
        text: t('userManagmentAdditional.grid.firstName'),
        flex: 1,
        type: "template",
        template: ({value}:any) => {
          return StringHelper.xss`${value ?? ""}`;
        }
      },
      {
        id:'lastName',
        field: 'lastName',
        text: t('userManagmentAdditional.grid.lastName'),
        flex: 1,
        type: "template",
        template: ({value}:any) => {
          return StringHelper.xss`${value ?? ""}`;
        }
      },
      {
        id:'email',
        field: 'email',
        text: t('userManagmentAdditional.grid.email'),
        flex: 1,
        type: "template",
        template: ({value}:any) => {
          return StringHelper.xss`${value ?? ""}`;
        }
      },
      {
        id:'phone',
        field: 'phone',
        text: t('userManagmentAdditional.grid.phone'),
        flex: 1,
        type: 'template',
        template: ({record}:any)=>{
          const data = record.data as User;
          return StringHelper.xss`${data.dialCode}${data.phoneNumber}`;
        }
      },
      {
        id:'roles',
        field: 'roles',
        text: t('userManagmentAdditional.grid.roles'),
        flex: 1,
        type: 'template',
        template: ({value}:any)=>{
          return value ? value.map((r:string) => t(`general.roles.${r}`)).join(", ") : "";
        }
      },
      {
        id:'product',
        field: 'products',
        text: t('userManagmentAdditional.grid.product'),
        flex: 1,
        type: 'template',
        template: ({value}:any)=>{
          return value ? value.join(", ") : "";
        }
      },
      {
        id:'companyId',
        field: 'applicationUserAdditional.companyId',
        text: t('userManagmentAdditional.grid.companyId'),
        flex: 1,
        type: 'template',
        template: ({record}:any)=>{
          const data = record.data as UserWithAdditional;
          return StringHelper.xss`${data.applicationUserAdditional?.companyId ?? ""}`;
        }
      },
      {
        id:'anAbSystemId',
        field: 'applicationUserAdditional.anAbSystemId',
        text: t('userManagmentAdditional.grid.anAbSystemId'),
        flex: 1,
        type: 'template',
        template: ({record}:any)=>{
          const data = record.data as UserWithAdditional;
          return StringHelper.xss`${data.applicationUserAdditional?.anAbSystemId ?? ""}`;
        }
      },
      {
        id:'anvSystemId',
        field: 'applicationUserAdditional.anvSystemId',
        text: t('userManagmentAdditional.grid.anvSystemId'),
        flex: 1,
        type: 'template',
        template: ({record}:any)=>{
          const data = record.data as UserWithAdditional;
          return StringHelper.xss`${data.applicationUserAdditional?.anvSystemId ?? ""}`;
        }
      },
      {
        id:'menu',
        text	: '',
        width   : 36,
        type	: 'widget',
        align: "center",
        hideable: false,
        resizable: false,
        sortable: false,
        filterable: false,
        widgets : [{
          type	 : 'button',
          width: 36,
          icon	 : 'icon-kontext_horizontal',
          onAction : ({ source: btn }:any) => {
            const menu = menuFactory(btn.cellInfo.record.data);
            menu.alignTo({ target: btn })
            menu.show();
          }
        }]
      },
    ],
    listeners:{
      async add(event:any){
        if(event.records.length === 1 && event.isMove[event.records[0].id]){
          await systemStore.saveUserColumnOrder(TableType[TableType.user], event.records[0].id, event.index.toString());
        }
      },
    }
  },
  store: gridStore,
  listeners: {
    selectionChange(event:any) {
      if(event.selection.length > 0 && event.selection[0]?.data === undefined) return;
      selectedUsers.value = selectedUsers.value.concat(event.selected.map(f=> f.data))
      selectedUsers.value = selectedUsers.value.filter(f => !event.deselected.map(fd => fd.data).some(fd => fd?.id === f?.id));
    },
    datachange(){
      systemStore.currentItems = gridStore.count;
      systemStore.allItems = gridStore.getCount();
    },
  },
  height: currentWindowHeight,
}
const gridConfig = reactive(useGridConfig)

const menuFactory = (record:object) => {
  const menu = new Menu({
    anchor   : true,
    autoShow : true,
    items	: [
      {
        text: t('global.edit'),
        cls: 'color',
        icon: 'icon-editieren',
        weight: 100,
        onItem : async ({ menu }:any) => {
          systemStore.openPopup({
            data: menu.record,
            action: addOrUpdateUser,
            resetButton:false,
            title:t("userManagmentAdditional.popups.addOrUpdate.title.edit"),
            type:PopupType.addOrUpdateUserPopup
          });
        }
      },
      {
        text: t('global.delete'),
        cls: 'color',
        icon: 'icon-loeschen',
        weight: 100,
        onItem : async ({ menu }:any) => {
          const answer = await dialog
              .okText(t('global.delete'))
              .cancelText(t('global.cancel'))
              .confirm(t('userManagmentAdditional.confirmDeletionSingle', {name:`${menu.record.firstName} ${menu.record.lastName}`}));

          if (answer) {
            const resp = await userSerivce.deleteUser(menu.record.id, ErrorLocationType.table);
            if(resp !== "") return;

            gridStore.applyChangeset({removed:[{id:menu.record.id}]});

            systemStore.showSuccess(t("global.deleted"));
          }
        }
      },
    ],
  });

  menu.setRecord(record);

  return menu;
};


const addOrUpdateUser = async () => {
  const user = systemStore.modal.contentObject as User;

  const createResp = await userSerivce.addOrUpdateUser(user, ErrorLocationType.popup);
  if(!createResp) return;


  if(user.id === '' || user.id === undefined) user.id = createResp.id;

  // in case you change your own roles, set the systemStore accordingly
  if(user.id === systemStore.user?.id) systemStore.user.roles = user.roles;

  // in case of an update bryntum automatically replaces the entry with the same ID
  gridStore.add(user);
  // reapply sorting
  await gridStore.sort(gridStore.sorters);
  // reapply filtering
  await gridStore.filter({
    id: "userFilter",
    filterBy: FilterService.buildFilter(TableType[TableType.user])
  });

  systemStore.closeModal();
  systemStore.showSuccess('Gespeichert');
}

const newUser = async ()=>{
  systemStore.openPopup({
    data:new User(),
    action: addOrUpdateUser,
    resetButton:false,
    title:t("userManagmentAdditional.popups.addOrUpdate.title.add"),
    type:PopupType.addOrUpdateUserPopup
  });
}

const deleteSelection = async ()=>{
  //drop call without selection
  if(!selectedUsers.value?.some(()=>true)) return;

  const answer = await dialog
      .okText(t("global.delete"))
      .cancelText(t("global.cancel"))
      .confirm(t("userManagmentAdditional.confirmDeletionMulti", { count:selectedUsers.value.length}));

  if (answer) {
    let someEntriesFailed = false;
    for (const u of selectedUsers.value){
      const resp = await userSerivce.deleteUser(u.id, ErrorLocationType.table);
      if(resp !== ""){
        someEntriesFailed = true;
        continue;
      }

      gridStore.applyChangeset({removed:[{id:u.id}]});
    }

    if (someEntriesFailed) return;

    systemStore.showSuccess(t("global.deleted"));
  }
}

const openCsvImport = () => {
  systemStore.openPopup({
    data:{anabUsers:false},
    action: async () => {
      const file = systemStore.uploadedFile;
      console.log("file to upload",file)
      if(!file) return;

      const usersType = (systemStore.modal.contentObject as {anabUsers:boolean}).anabUsers
          ? UsersType.anab
          : UsersType.anv;

      console.log("userType", usersType)

      const resp = await userSerivce.postUserCsvImport(file as File, usersType, ErrorLocationType.popup)
      console.log("response", resp)
      if(!resp) return

      // reset tmp-file-holder for space purposes
      systemStore.uploadedFile = null;

      // update globalStore data and filters etc
      await setGridData()

      systemStore.closeModal()
      systemStore.showSuccess(t('global.saved'))
    },
    resetButton:false,
    title:t("userManagmentAdditional.popups.importUsers.title"),
    type:PopupType.importUsersPopup
  });
}

const exportCsv = () => {
  const rawData = selectedUsers.value?.length > 0 ? selectedUsers.value : gridStore.records;

  // remove unnecessary properties from csv
  const csvData = rawData.map((item)=> new UserCsvExport(item.data ?? item));

  const fileName = t('userManagmentAdditional.exportFilename');
  const exportType =  exportFromJSON.types.csv;

  exportFromJSON({
    data:csvData,
    fileName:fileName,
    exportType:exportType,
  });
};

const setGridData = async () => {
  // start spinner
  systemStore.gridDataIsLoading = true;

  const userData = await userSerivce.getUsersWithAdditionalData(ErrorLocationType.table);
  if (!userData) return;

  gridStore.setStoreData(userData);

  // apply filters
  await gridStore.filter({
    id: "userFilter",
    filterBy: FilterService.buildFilter(TableType[TableType.user])
  });

  // apply hidden cols
  for(const c of grid.value.instance.value.columns.storage.values){
    const needsHiding = systemStore.userPreferences.userHiddenColumns
        .some((thc) => thc.attributeName === c.data.field && thc.tableName === TableType[TableType.user]);

    if(needsHiding && !c.hidden) {
      c.hide();
    }
    else if(!needsHiding && c.hidden && !featureColumn.includes(c.id)) {
      c.show();
    }
  }

  systemStore.reorderColumns(TableType[TableType.user]);

  // stop spinner
  systemStore.gridDataIsLoading = false;
}

onMounted(async ()=>{
  // calculate grid height and sub to window resize event
  recalcGridHeight();
  window.addEventListener('resize', recalcGridHeight);

  systemStore.setGridStore(ref(gridStore));
  systemStore.setGridColumnStore(ref(grid.value?.instance.value?.columns));

  // start spinner
  systemStore.gridDataIsLoading = true;
  await setGridData();
  // stop spinner
  systemStore.gridDataIsLoading = false;
})

onBeforeUnmount(async ()=>{
  window.removeEventListener('resize', recalcGridHeight);

  systemStore.setGridStore(null);
  systemStore.setGridColumnStore(null);

  systemStore.currentItems = 0;
  systemStore.allItems = 0;
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h4", null, _toDisplayString(_ctx.$t("userManagmentAdditional.title")), 1)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("div", null, [
        _createVNode(Error, {
          errorLoc: _unref(ErrorLocationType).table
        }, null, 8, ["errorLoc"]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              class: "primary mr-2",
              onClick: newUser,
              title: _unref(t)('userManagmentAdditional.new'),
              id: "createNew"
            }, _hoisted_7, 8, _hoisted_5),
            _createElementVNode("button", {
              class: "primary mr-2",
              onClick: deleteSelection,
              title: _unref(t)('global.delete'),
              disabled: !selectedUsers.value.some(()=>true),
              id: "deleteSelection"
            }, _hoisted_10, 8, _hoisted_8),
            _createElementVNode("button", {
              class: "primary mr-2",
              onClick: openCsvImport,
              title: _unref(t)('global.importCsv'),
              id: "openCsvImport"
            }, _hoisted_13, 8, _hoisted_11),
            _createElementVNode("button", {
              class: "primary mr-2",
              onClick: exportCsv,
              title: _unref(t)('global.exportCsv'),
              disabled: !selectedUsers.value.some(()=>true),
              id: "exportCsv"
            }, _hoisted_16, 8, _hoisted_14),
            _createElementVNode("div", _hoisted_17, [
              _createVNode(GridInputFilter, {
                gridStore: _unref(gridStore),
                hideFilterButton: true
              }, null, 8, ["gridStore"])
            ])
          ]),
          _createVNode(_unref(BryntumGrid), _mergeProps({
            ref_key: "grid",
            ref: grid
          }, gridConfig, { readOnly: true }), null, 16)
        ])
      ], 512), [
        [_vShow, !_unref(systemStore).gridDataIsLoading]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_18, [
        _createVNode(LoadingSpinner)
      ], 512), [
        [_vShow, _unref(systemStore).gridDataIsLoading]
      ])
    ])
  ], 64))
}
}

})